import React from 'react';
import NestedStepsTable from 'common/pages/fleetV2/machine/aseptic/views/MachineHealth/components/SingleSessionSteps/NestedStepsTable';
import { SipNestedTable } from 'common/pages/fleetV2/machine/aseptic/views/MachineHealth/components/SipTableWidget/SipNestedTable';
import { use } from 'i18next';
import NestedProductOrderHistory from 'components/NewSFOrdersTable/NestedProductOrderHistory';

type Props = {
  data: any;
  type: string;
};

const NestedTable = ({ data, type }: Props): JSX.Element => {
  //const [tableData, setTableData] = React.useState<any[]>([]);

  return type === 'singleSessionStep' ? (
    <NestedStepsTable data={data} />
  ) : type === 'siptable' ? (
    <SipNestedTable data={data} />
  ) : type === 'twowayorder' ? (
    <NestedProductOrderHistory products={data} />
  ) : (
    <></>
  );
};

export default NestedTable;
